module.exports = __webpack_public_path__ + "static/p09_pararoRvolandoAlaR-37f8314902d15f86ce9991fe89db1380.png";